import React, { useContext } from "react";
import "./ReservationSchedulerNew.css";
import { AppContext } from "../../../context/AppContext";
import { toast } from "react-toastify";

function ConfrimPopup({
  close,
  eventId,
  setEventId,
  showConfrim,
  setShowConfirm,
}) {
  const {
    deleteReservation,
    reservationLoading,
    fetchFutureReservations,
    upcomingwithtodaysReservationList,
  } = useContext(AppContext);
  if (!showConfrim) return;

  const handleDeleteEvent = async () => {
    const eveSessId = window.sessionStorage.getItem("eventID");
    if (!eventId || !eveSessId || eveSessId == 0 || eventId == 0) {
      console.log(eventId, eveSessId);
      toast.error("Invalid Event ID");
      return;
    }

    const eId = eventId ? eventId : eveSessId;

    await deleteReservation(eId, {
      onSuccess: async (res) => {
        window.sessionStorage.removeItem("eventID");
        setEventId(0);
        toast.success("Reservation deleted successfully!");
        await fetchFutureReservations();
        await upcomingwithtodaysReservationList();
        setShowConfirm(false);
      },
      onFailed: (err) => {
        console.error("Error on deleting reservation", err);
      },
    });
  };
  return (
    <div className="confirm_wrapper">
      <div className="confirm_content">
        <h3>Are you sure you want to delete this event?</h3>
        <p className="confirm_text-main">
          <strong>This process is irreversible.</strong>
        </p>
        <p className="confirm_text-extra">
          Once deleted, all related details such as attendees, reminders, and
          notes will be permanently removed and cannot be restored.
        </p>
        <div className="button_grp">
          <button
            type="button"
            className="btn btn_primary"
            onClick={handleDeleteEvent}
            disabled={reservationLoading}
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn_secondary"
            onClick={close}
            disabled={reservationLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfrimPopup;
